import en from "./en";
import ja from "./ja";

export const footer = {
  en,
  ja
}